/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getDetailPagoConsulta } from "../../Api";
import { formatCurrency } from '../../Functions'

const QueryDetailBruto = (props) => {
  const {razonsocial, fechaproceso, rut, tipopago, estado, fechapago, resumen_input_tipo_pago, resumen_input_prestador, resumen_input_fecha} = props;
  const [state, setState] = useState({
    data_pago_consulta: [],
    loading: true
  });

  const _getDetailPagoConsulta = async () => {
    
    if (!resumen_input_tipo_pago) {
      return;
    }

    const _response = await getDetailPagoConsulta({
      resumen_input_tipo_pago: resumen_input_tipo_pago,
      resumen_input_prestador: resumen_input_prestador,
      resumen_input_fecha: resumen_input_fecha,
    });
    if (_response.status) {
      setState({
        data_pago_consulta: _response.data,
        loading: false,
      });
    }
  }

  useEffect(() => {
    _getDetailPagoConsulta();
  }, [props])
  

  return (
    <>
      {!state.loading && (
        <>
          <div className="row">
            <div className={`col-12 table-responsive ${state.loading ? 'table-loading-overlay' : ''}`} >
              <table className="table table-bordered table-payment-resume">
                <thead className="fs-6 text-white">
                  <tr>
                    <th>Rut</th>
                    <th>Razón Social</th>
                    <th>Tipo</th>
                    <th>Estado</th>
                    <th>Fecha de proceso</th>
                    <th>Fecha de Transferencia</th>
                  </tr>
                </thead>
                <tbody className="fs-6 text-gray-800">
                  <tr>
                    <td>{rut}</td>
                    <td>{razonsocial}</td>
                    <td>{tipopago}</td>
                    <td>{estado}</td>
                    <td>{fechaproceso}</td>
                    <td>{fechapago}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className={`col-12 table-responsive ${state.loading ? 'table-loading-overlay' : ''}`} >
              <table className="table table-bordered table-payment-resume">
                <tbody className="fs-6 text-gray-800">
                {state.data_pago_consulta?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.description}</td>
                      <td>{formatCurrency(item.valor)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default QueryDetailBruto;